var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButtonItsumoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 34,
    viewBox: "0 0 68 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 34,
    rx: 10,
    fill: "#28AF06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5201 22.4443H16.3681V18.1183C16.3681 17.1383 16.2141 15.6963 16.1021 14.7163H16.1581L16.9981 17.1523L18.5941 21.5203H19.7841L21.3801 17.1523L22.2341 14.7163H22.3041C22.1921 15.6963 22.0241 17.1383 22.0241 18.1183V22.4443H23.9141V12.0843H21.6181L19.8961 16.9423C19.6861 17.5863 19.5041 18.2583 19.2661 18.9303H19.2101C18.9861 18.2583 18.8041 17.5863 18.5661 16.9423L16.8021 12.0843H14.5201V22.4443ZM26.4556 22.4443H32.9656V20.7083H28.5276V17.9503H32.1536V16.2003H28.5276V13.8063H32.8116V12.0843H26.4556V22.4443ZM35.0689 22.4443H37.0289V18.3003C37.0289 17.0963 36.8609 15.7943 36.7629 14.6883H36.8329L37.8829 16.9003L40.8789 22.4443H42.9929V12.0843H41.0189V16.2143C41.0189 17.3903 41.1869 18.7763 41.2989 19.8543H41.2289L40.1789 17.6143L37.1689 12.0843H35.0689V22.4443ZM49.5313 22.6403C52.0653 22.6403 53.5353 21.2263 53.5353 17.7963V12.0843H51.5473V17.9783C51.5473 20.1203 50.7493 20.8483 49.5313 20.8483C48.3133 20.8483 47.5573 20.1203 47.5573 17.9783V12.0843H45.4993V17.7963C45.4993 21.2263 46.9973 22.6403 49.5313 22.6403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonItsumoni);
export default __webpack_public_path__ + "static/media/menu-button_itsumoni.3c7fd3010ea03aa50a01a7c117240311.svg";
export { ForwardRef as ReactComponent };